import { object, string } from "yup";

export const SelectPositionsToUpdateSchema = object().shape({
  updateTypes: string().required("A selection must be chosen"),
});
